module.exports = __webpack_public_path__ + "img/ometeotl.f98a88ce.png";